import React, { useEffect } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import ReconnectBanner from '../components/status/ReconnectBanner';
import useAppStore from '../store';

const NAV_ITEMS = [
  { to: '/client/home', label: 'Home' },
  { to: '/client/activity', label: 'Activity' },
  { to: '/client/billing', label: 'Billing' },
  { to: '/client/support', label: 'Support' }
];

/**
 * Client persona shell (T9.6/T9.7): light theme + tenant white-labeling.
 * Brand identity comes from sessionSlice.tenantRecord (name + primaryColor);
 * colors flow through CSS custom properties, never inline style colors on
 * elements. Agency screens stay dark (ops-dark) in parallel.
 */
function ClientLayout() {
  const navigate = useNavigate();
  const tenantRecord = useAppStore((state) => state.tenantRecord);
  const session = useAppStore((state) => state.session);
  const clearSessionAction = useAppStore((state) => state.clearSession);

  // Apply tenant branding as CSS custom properties on the shell root (T9.6).
  useEffect(() => {
    if (tenantRecord?.primaryColor) {
      document.documentElement.style.setProperty('--tenant-primary', tenantRecord.primaryColor);
    }
    return () => {
      document.documentElement.style.removeProperty('--tenant-primary');
    };
  }, [tenantRecord]);

  const handleSignOut = () => {
    clearSessionAction();
    navigate('/login', { replace: true });
  };

  return (
    <div className="client-shell theme-light">
      <header className="client-topbar">
        <NavLink className="client-brand" to="/client/home">
          {tenantRecord.logoUrl
            ? <img alt={tenantRecord.name} className="client-brand-logo" src={tenantRecord.logoUrl} />
            : <span className="client-brand-mark" aria-hidden="true">{tenantRecord.name.slice(0, 1)}</span>}
          <span className="client-brand-name">{tenantRecord.name}</span>
          <span className="client-brand-tag">CLIENT PORTAL</span>
        </NavLink>
        <nav aria-label="Portal">
          {NAV_ITEMS.map((item) => (
            <NavLink
              className={({ isActive }) => (isActive ? 'client-nav-link active' : 'client-nav-link')}
              key={item.to}
              to={item.to}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="client-user">
          <span>{session?.user?.name}</span>
          <button onClick={handleSignOut} type="button">Sign out</button>
        </div>
      </header>
      {/* S7.1/S7.2: stale/lost-connection banner — client portal must also
          never sit on stale data silently. */}
      <ReconnectBanner />
      <Outlet />
      <footer className="client-footer">
        <span>Powered by AGI Agency · your data stays tenant-isolated</span>
      </footer>
    </div>
  );
}

export default ClientLayout;
